<template>
  <div class="info-skeleton">
    <SkeletonItem
      class="info-skeleton__title"
      width="320px"
      height="36px"
      :border-radius="8"
      :is-animated="animated"
      ignore-global-animation
    />
    <div class="info-skeleton__lines">
      <SkeletonItem
        width="100%"
        height="16px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
      <SkeletonItem
        width="90%"
        height="16px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
      <SkeletonItem
        width="70%"
        height="16px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';

  withDefaults(
    defineProps<{
      animated?: boolean;
    }>(),
    {
      animated: true,
    },
  );
</script>

<style scoped lang="scss">
  .info-skeleton {
    margin-top: 48px;

    &__title {
      @include mobile {
        width: 240px;
        height: 28px;
      }
    }

    &__lines {
      display: flex;
      flex-direction: column;
      gap: 12px;
      max-width: 805px;
      margin-top: 16px;
    }

    @include tablet {
      margin-top: 40px;
    }
  }
</style>
